import graphql from "babel-plugin-relay/macro";

const createPictureMutation = graphql`
  mutation createPictureMutation($id: ID!) {
    recipeMediaCreate(input: { recipe: $id }) {
      recipeMedia {
        id
        file
      }
    }
  }
`;

export default createPictureMutation;
